export default class Command {
    constructor(item) {
        this.id = item != null ? item.id : '';
        this.companyId = item != null ? item.companyId : ''
        this.priceAgreementId = item != null ? item.priceAgreementId : ''
        this.name = item != null ? item.name : '';
        this.type = item != null ? item.type : '';
        this.isVariable = item != null ? item.isVariable : false;
        this.typeName = item != null ? item.typeName : '';
        this.price = item != null ? item.price : 0
        this.quantity = item != null ? item.quantity : 1
        this.startdate = item != null ? item.startdate : '';
        this.enddate = item != null ? item.enddate : '';
    }
}